import React from "react";
import ResetComponent from "../../components/forms/Reset";
import img1 from "../../assets/images/img1.png";
import img2 from "../../assets/images/img2.png";
import logo from "../../assets/images/CoreVentum_logo_dark.png";;
function Reset() {
  return (
    <div
      className="h-screen w-full bg-cover bg-center relative flex"
      style={{ backgroundImage: `url(${img2})` }}
    >
      <nav className="pl-3 pt-4">
        <img src={logo} alt="" width={180} height={150} />
      </nav>
      <div className="absolute top-2 left-[15%] lg:w-[40%] xl:w-[45%]">
        <h1 className="text-white font-bold text-[17px] leading-10">Contract Life-Cycle Management Software (CLMS)</h1>
        <img
          src={img1}
          alt="Top Right"
          className=""
        />
      </div>

      <div className="absolute bottom-16 right-14 w-full max-w-[450px] z-20">
        <ResetComponent />
      </div>
    </div>
  );
}

export default Reset;
